var opticTypeSelect = null;
var opticBrandSelect = null;
var opticModelSelect = null;
var searchButton = null;

let lastRequestTime = 0;
let inFlightRequest = null;

/**
  * Initialiaizes the compatibility checker. It gets the data, all of the elements on the page
  */
async function initCompatibilityChecker() {
  fetchOpticsData().then(data => {
    window.opticsData = data;

    // If the user already selected a type before data loaded:
    const selectedType = opticTypeSelect.value;
    if (selectedType) {
      populateBrands(selectedType);
    }
  });

  opticTypeSelect = document.getElementById("opticType");
  opticBrandSelect = document.getElementById("opticBrand");
  opticModelSelect = document.getElementById("opticModel");
  searchButton = document.querySelector(".search-button");

  // If any of the dropdowns or search button are missing, the program exits
  if (
    !opticTypeSelect ||
    !opticBrandSelect ||
    !opticModelSelect ||
    !searchButton
  ) {
    console.error("One or more DOM elements not found");
    showToast("Whoops! Something’s missing here.", "error");
    return;
  }

  // Runs when the user changes the type of product (i.e. spotting scope or binocular)
  opticTypeSelect.addEventListener("change", function () {
    // console.log("Optic type changed to:", this.value);
    const resultDiv = document.getElementById('searchResult');
    resultDiv.innerHTML = '';
    populateBrands(this.value);
  });

  // Runs when the user changes the selected brand (i.e. Alpen or Athlon)
  opticBrandSelect.addEventListener("change", function () {
    const type = opticTypeSelect.value;
    // console.log("Brand changed to:", this.value, "for type:", type);
    if (type && this.value) {
      populateModels(type, this.value);
    } else {
      opticModelSelect.innerHTML =
        '<option value="">Choose a Brand First!</option>';
      opticModelSelect.disabled = true;
    }
  });

  // Runs `searchOptic()` when the user clicks the "Hunt for your optic" button
  searchButton.addEventListener("click", searchOptic);
}

/**
 * Fetches the optics data from cache. This stores the data in the users browser for 1 hour. This
 * limits the amount of requests a specific user can call the API endpoint (i.e. multiple refreshes).
 */
async function fetchOpticsData() {
  const now = Date.now();

  // 1. Check cache
  const cached = localStorage.getItem(window.cacheKey);
  if (cached) {
    console.log("Data is cached!")
    const parsed = JSON.parse(cached);
    if (now - parsed.timestamp < window.cacheTTL) {
      return parsed.data;
    }
  }

  // 2. Rate limit: return in‑flight request if too soon
  // This deduplicates multiple requests per user
  if (inFlightRequest && now - lastRequestTime < window.rateLimit) {
    return inFlightRequest;
  }

  // 3. Make a new request
  lastRequestTime = now;
  inFlightRequest = fetchOpticsDataSheets().then(result => {
    localStorage.setItem(
      window.cacheKey,
      JSON.stringify({ timestamp: now, data: result })
    );
    return result;
  }).finally(() => {
    inFlightRequest = null;
  });

  return inFlightRequest;
}


/**
 * This function attemps to fetch the data from the Google Sheets master list. If this
 * fails, then the program will default to collecting it from the backend JSON.
 * 
 * @return data object of all of the optics data
 */
async function fetchOpticsDataSheets() {
  console.log("Fetching from Google Sheets!");
  try {
    const response = await fetch(window.opticsDataUrl);
    const data = await response.json();

    if (!data.success) {
      console.error('API Error:', data.error);
      return fetchOpticsDataJSON();
    }

        // This section builds out the structure of the data object (its just building a JSON format from rows of data)
        const result = {};
        data.rows.forEach(item => {
          const type = item.Type;
          const brandRaw = item.Brand;
          const brandKey = brandRaw.trim().toLowerCase();   // normalized key
          const modelKey = `${item.Model} ${item["Range and Size"]}`;

          if (!result[type]) result[type] = {};
          if (!result[type][brandKey]) {
            result[type][brandKey] = {
              __label: brandRaw,   // store original capitalization
              models: {}
            };
          }

          result[type][brandKey].models[modelKey] = {
            spacer: item.Spacer,
            message: item.Message
          };
        });


        // If the result of the google sheets operation is null, collect it from the JSON
        if (result == null || result.length == 0) {
          console.log("Sheets result is empty, fetching from JSON...");
          return fetchOpticsDataJSON();
        }

        return result;

      } catch (err) {
        // If there was an error in any of the steps above, just collect it from the JSON
        console.error("Invalid JSON:", err);
        console.log("Error with Sheets collection, fetching from JSON...");
        return fetchOpticsDataJSON();
  }
}


/**
 * Gets the data from the `opticsData.json` file and returns it.
 * 
 * @return the data stored within `opticsData.json`
 */
async function fetchOpticsDataJSON() {
  try {
    console.log("Fetching from JSON!");
    
    // The variable `window.OpticsDataJSON.url` is set by line 10 in the `compatibility-checker.liquid` file.
    const response = await fetch(window.OpticsDataJSON?.url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const json = await response.json();
    console.log("JSON fallback loaded:", json);

    // Convert old format into new normalized format
    return normalizeFormat(json);

  } catch (err) {
    console.error("JSON fallback failed:", err);

    showToast(
      "Whoops! Can’t load data—try again or check ad blockers.",
      "error"
    );

    document.getElementById("searchResult").innerHTML =
      "<p>Whoops! Can’t load data—try again or check ad blockers.</p>";

    return null;
  }
}



/**
 * Transforms JSON file of data into the format required by the system.
 */
function normalizeFormat(data) {
  const result = {};

  for (const type in data) {
    if (!result[type]) result[type] = {};

    for (const brandRaw in data[type]) {
      const brandKey = brandRaw.trim().toLowerCase();

      // Create brand entry only if it doesn't exist
      if (!result[type][brandKey]) {
        result[type][brandKey] = {
          __label: brandRaw,   // keep original capitalization
          models: {}
        };
      }

      const models = data[type][brandRaw];

      // Merge models instead of overwriting
      for (const modelKey in models) {
        result[type][brandKey].models[modelKey] = {
          spacer: models[modelKey].spacer,
          message: models[modelKey].message
        };
      }
    }
  }

  return result;
}




/**
 * Populates the brands dropdown once a product type has been selected.
 * 
 * @param type: the type of product, i.e. spotting scope or binocular
 */
function populateBrands(type) {
  opticBrandSelect.innerHTML =
    '<option value="">' +
    (type ? "Choose Your Brand Vibe!" : "Pick an Optic Type First!") +
    "</option>";
  opticModelSelect.innerHTML =
    '<option value="">Choose a Brand First!</option>';
  opticBrandSelect.disabled = !type;
  opticModelSelect.disabled = true;

  // If data is missing for product type, then we exit this function.
  if (!type || !window.opticsData[type]) {
    // console.log("No data for type:", type);
    return;
  }

  // Selects all the brands beneath the product type and appends it to the dropdown list of brands.
  const brands = Object.keys(window.opticsData[type]).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })); // Sort and ignore case 
  brands.forEach((brand) => {
    const option = document.createElement("option");
    option.value = brand;
    option.textContent = window.opticsData[type][brand].__label; // original spelling;
    opticBrandSelect.appendChild(option);
  });

  // If there are results in the brands dropdown, then this code runs and automatically selects the 
  // first option within the dropdown. 
  if (brands.length > 0) {
    opticBrandSelect.value = brands[0];
    populateModels(type, brands[0]);
  }
}

/**
 * Populates the models once both a product type and a brand have been selected.
 * 
 * @param type: the type of product, i.e. spotting scope or binocular
 * @param brand: the product brand, i.e. Alpen or Athlon
 */
function populateModels(type, brand) {
  opticModelSelect.innerHTML =
    '<option value="">' +
    (brand ? "Find Your Model Match!" : "Choose a Brand First!") +
    "</option>";
  opticModelSelect.disabled = !brand;

  // If data is missing for either the product type or brand, then we exit this function.
  if (
    !window.opticsData ||
    !window.opticsData[type] ||
    !window.opticsData[type][brand]
  ) {
    // console.log("No data for type:", type, "brand:", brand);
    return;
  }

  // Selects all the models beneath the product brand and appends it to the dropdown list of models.
  const models = Object.keys(window.opticsData[type][brand].models).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })); // Sort and ignore case 
  models.forEach((model) => {
    const option = document.createElement("option");
    option.value = model;
    option.textContent = model;
    opticModelSelect.appendChild(option);
  });
}

/**
 * Searches for the compatible optic based on the values selected in the previous dropdowns (i.e. type, brand, model).
 */
function searchOptic() {
  if (!window.opticsData) {
    showToast("Data’s still loading—give it a sec!", "error");
    document.getElementById("searchResult").innerHTML =
      "<p>Data’s still loading—give it a sec!</p>";
    return;
  }
  const type = opticTypeSelect.value;
  const brand = opticBrandSelect.value;
  const model = opticModelSelect.value;
  const resultDiv = document.getElementById("searchResult");
  resultDiv.innerHTML = "";

  // If any of the selected dropdowns are empty, then we exit this function (we can't search for a compatible optic without the necessary fields).
  if (!type || !brand || !model) {
    showToast("Oops! Pick all options first!", "error");
    document.getElementById("searchResult").innerHTML =
      "<p>Oops! Pick all options first!</p>";
    return;
  }

  const spacer = window.opticsData[type]?.[brand]?.models?.[model]?.spacer; // The type of spacer compatible as listed in the `opticsData.json` file
  const productMessage = window.opticsData[type]?.[brand]?.models?.[model]?.message; // If that compatible spacer contains a unique message (i.e. separate purchase necessary).

  let shopifyProduct = null;
  if (window.productVariants)
    shopifyProduct = window.productVariants[0].name.toLowerCase()

  let matchingVariant = findMatchingVariant(spacer); // Finds the matching product variant stored within the Shopify store's products

  // If a matching variant was found, display a message reading the result of the search, automatically select it in the checkout dropdown, and scroll to the checkout
  if (matchingVariant) {
    const optionSelectors = document.querySelectorAll(
      'select[name^="options"]',
    );

    // Set the values of each option selector (this represents the product dropdown and color dropdown next to the checkout button)
    if (optionSelectors.length > 0) {
      let optionValue = null;
      optionSelectors.forEach((selector, index) => {

        // If the `products` dropdown next to the checkout button contains an option that matches the `matching variant` determined by the `findMatchingVariant()` function,
        // then we actively select that option for the customer so they have the correct compatible product selected for checkout.
        optionValue = matchingVariant[`option${index + 1}`]; 
        if (optionValue) {
          selector.value = optionValue;

          // Trigger a change event to let Shopify’s variant script pick up the new selection. This just forces the page to display the change in selected product.
          const event = new Event("change", { bubbles: true });
          selector.dispatchEvent(event);

          // Scrolls the checkout button into view.
          selector.scrollIntoView({
            behavior: "smooth",
            block: "center", // or 'start' or 'end'
          });

          // Displays the result of the product being selected as well as any potential messages that might have been found by the compatibility checker (i.e. separate product sold separately).
          let toastMessage = `Bingo! ${spacer} is compatible and has been selected!`;
          let toastType = 'success'
          if (productMessage) {
            toastMessage += ` NOTE: ${productMessage}`;
            toastType = 'warning'
          }

          showToast(toastMessage, toastType);
          document.getElementById("searchResult").innerHTML =
            `<p>Select your optic’s adapter size below: <strong>${spacer}</strong></p>`;
        }
      });
    } else {
      console.error("No matching options selector. Attempting to find a hidden input selector...");

      // If there's no visible selector (uncommon), fallback to updating the hidden input. This is a safety net in case the above section did not work.
      let variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = matchingVariant.id;
      }
    }
  } else if (window.pageTitle == 'Sizing Compatibility') {
    let toastMessage = `Bingo! ${spacer} is compatible!`;
    let toastType = 'success'
    if (productMessage) {
      toastMessage += ` NOTE: ${productMessage}`;
      toastType = 'warning'
    }

    showToast(toastMessage, toastType);

    // Push the Div that displays the button below to snag your adapter
    const resultDiv = document.getElementById('searchResult');
    resultDiv.innerHTML = `
        <p>Your optic’s perfect adapter size is: <strong>${spacer}</strong></p>
        <a href="https://onglassadapter.com/products/on-glass-digiscope-3-1" class="purchase-button">Snag Your Adapter Now</a>
    `;

  } else if (shopifyProduct != null && shopifyProduct.includes("og mini")) { // Page to determine compatibility with OG Mini
    let toastMessage;
    let toastType;

    // Compatible with OG Mini
    if (productMessage != null && productMessage.toLowerCase().includes("og mini")) {
      toastMessage = `Bingo! Your optic is compatible with the OG Mini!`;
      toastType = 'success'
    } else { // Incompatible with OG Mini
      toastMessage = `Your optic is incompatible with the OG Mini.`;
      toastType = 'error'
    }

    showToast(toastMessage, toastType);

  }  else {
    console.error("No matching variant found for this optic.");
    showToast("No matching variant found for this optic.", "error");
  }
}


/**
 * Searches through the products stored in Shopify and finds a matching one based on product name.
 * 
 * @param spacer: the selected spacer
 * @return the matching product variant provided by the `opticsData.json` file
 */
function findMatchingVariant(spacer) {
  // This is typically used in the case of the Sizing Compatibility page
  if (window.productVariants == null || window.pageTitle == 'Sizing Compatibility')
    return null;

  spacer = spacer.toLowerCase();

  // Iterates through Shopify's listed products and returns a result if the product name (i.e. 'Charlie')  
  // or option (i.e. 'Charlie 1.75 - 1.84') matches the spacer (i.e. 'Charlie') listed in the optics data json file.
  let matchingVariant = window.productVariants.find((variant) => {
      return (
        (variant.title?.toLowerCase().includes(spacer)) ||
        (variant.option1?.toLowerCase().includes(spacer))
      )
  });

  return matchingVariant;
}


/**
 * Displays a message banner across the screen.
 * 
 * @param message: the message you are wanting to display on the toast banner
 * @param type: the type of message, i.e. success, warning, error, etc.
 */
function showToast(message, type) {
  // Remove any existing toast
  const existingToast = document.querySelector(".toast");
  if (existingToast) {
    existingToast.remove();
  }

  const toast = document.createElement("div");
  toast.className = `toast ${type}`;
  toast.innerHTML = `
              <div class="toast-content" role="status" aria-live="polite"> 
                <p>${message}</p>
                <span class="close">×</span>
              </div>
            `;
  document.body.appendChild(toast);

  // Slide in
  setTimeout(() => {
    toast.classList.add("show");
  }, 100);

  // Handle close button
  const closeButton = toast.querySelector(".close");
  closeButton.addEventListener("click", () => {
    toast.classList.remove("show");
    setTimeout(() => toast.remove(), 300);
  });

  // This is time in milliseconds, i.e. 10,000 is 10 seconds
  let timelimit = 10000
  let fadeout = 9200
  if (type == 'warning' || type == 'error') {
    timelimit = 15000
    fadeout = 14200
  }

  // Fade out after 14.2 seconds, fully disappear by 15 seconds
  setTimeout(() => {
    toast.style.opacity = "0";
  }, fadeout);

  setTimeout(() => {
    toast.remove();
  }, timelimit);
}

document.addEventListener("shopify:section:load", initCompatibilityChecker());
